module.exports = __webpack_public_path__ + "assets/62c10744281bad71bb014df56159fb27.svg";